import { IconContext } from "@phosphor-icons/react";
import { classNames } from "@/utils/classNames";
import { iconMap, IconName } from "./iconMapping";

import { FgColor, fgColorClassName } from "./colors";
import { SVGAttributes } from "react";

export type IconColor = FgColor;

export type IconProps = {
  name: IconName;
  /** Defaults to "context" */
  size?: "context" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "mega" | "jumbo";
  weight?: "regular" | "bold" | "light" | "thin" | "fill";
  color?: IconColor;
  rotate?: number;
  className?: string;
  duotone?: boolean;
} & SVGAttributes<SVGElement>;

function sizeToCssValue(size: IconProps["size"]) {
  switch (size ?? "md") {
    case "context":
      return "1em";
    case "xs":
      return 12;
    case "sm":
      return 16;
    case "md":
      return 20;
    case "lg":
      return 24;
    case "xl":
      return 32;
    case "xxl":
      return 50;
    case "mega":
      return 104;
    case "jumbo":
      return 160;
  }
}

export function Icon({
  name,
  size,
  weight,
  color,
  className,
  rotate,
  duotone,
  ...props
}: IconProps) {
  return (
    <IconContext.Provider
      value={{
        color: "currentColor",
        size: sizeToCssValue(size),
        weight: duotone ? "duotone" : weight,
        mirrored: false,
        className: classNames(
          className,
          fgColorClassName(color),
          "flex-none",
          duotone && "duotone-blue",
        ),
        style: rotate ? { transform: `rotate(${rotate}deg)` } : undefined,
        ...props,
      }}
    >
      {iconMap[name]}
    </IconContext.Provider>
  );
}
